import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * Created by haikuan.gu@qunar.com
 * Date: 2020/5/26
 * Time: 10:26 上午
 *
 */
import qs from 'qs';
import Ext from './core';
import errorHandler from './errorHandler';

function callNativeAPI(namespace, APIName, args) {
  // 先支持 sendScheme
  var _args = _slicedToArray(args, 1),
      url = _args[0];

  if (url) {
    // qunariphone://hy?url=https%3A%2F%2Ftouch.train.qunar.com%2Factive%2Fpostcard.html&type=navibar-none
    // qunariphone://react/open?hybridId=uni_rn&pageName=Detail&initProps=%7B%22name%22%3A%22lisi%22%2C%22age%22%3A12%7D
    // qunariphone://pcenter/launchMiniProgram?userName=gh_7ffb9c5d761f&path=/pages/ppTrip/focusWechat/index%3Fscene%3Dppxc%26source%3Dpporder%26hasBind%3D1%26hasFocus%3D0%26contentImg%3Dhttps%25253A%25252F%25252Fpicbed.qunarzz.com%25252F9bbe4b97b8b0b531d6c1d24490e16505.png%26_q%3DU.cdcxkxr7658%26_v%3DQsblyRvdgHZOLGLjoC9bl988XsH3XjTvfAjB-d828F4wdWKjJGAde1S4LIL0VjxpQ3T2A3UOdymv5XF8bs0KR0O4-yMufsDoBN5pGur7JNNPMJkZ6UaG-RYdyEzrjclFyqKjO0QHZSu8ec5m91Jk2g7-ag0XVCYdUQyzP30efZ4g%26_t%3D26761373&miniprogramType=0
    // qunaraphone://share/launchMiniProgram?userName=gh_7ffb9c5d761f&path=/pages/ppTrip/focusWechat/index%3Fscene%3Dppxc%26source%3Dpporder%26hasBind%3D1%26hasFocus%3D0%26contentImg%3Dhttps%25253A%25252F%25252Fpicbed.qunarzz.com%25252F9bbe4b97b8b0b531d6c1d24490e16505.png%26_q%3DU.cdcxkxr7658%26_v%3DQsblyRvdgHZOLGLjoC9bl988XsH3XjTvfAjB-d828F4wdWKjJGAde1S4LIL0VjxpQ3T2A3UOdymv5XF8bs0KR0O4-yMufsDoBN5pGur7JNNPMJkZ6UaG-RYdyEzrjclFyqKjO0QHZSu8ec5m91Jk2g7-ag0XVCYdUQyzP30efZ4g%26_t%3D26761373&miniprogramType=release
    if (/hy\?/.test(url)) {
      var queryStr = url.split('?')[1];
      var query = qs.parse(queryStr);
      window.location.href = decodeURIComponent(query.url);
    } else if (/react\/open\?/.test(url)) {
      var _queryStr = url.split('?')[1];

      var _query = qs.parse(_queryStr);

      var _query$hybridId = _query.hybridId,
          hybridId = _query$hybridId === void 0 ? '' : _query$hybridId,
          _query$pageName = _query.pageName,
          pageName = _query$pageName === void 0 ? '' : _query$pageName,
          _query$initProps = _query.initProps,
          initProps = _query$initProps === void 0 ? '' : _query$initProps;

      if (Ext.defaults.hybridId === hybridId) {
        // 项目内部
        var openData = {};

        if (initProps) {
          openData.param = JSON.parse(decodeURIComponent(initProps));
        }

        Ext.open(pageName, openData);
      } else {
        // 项目外部
        alert(' hybridId is not same as current hybridId ');
      }
    } else if (/(pcenter|share)\/launchMiniProgram\?/.test(url)) {
      var _queryStr2 = url.split('?')[1];

      var _query2 = qs.parse(_queryStr2);

      var path = _query2.path; // todo 暂时只考虑同一个微信小程序内部跳转，跳转外部小程序使用 wx.navigateToMiniProgram(Object object)
      // https://developers.weixin.qq.com/miniprogram/dev/api/open-api/miniprogram-navigate/wx.navigateToMiniProgram.html

      Ext.openWechatPage(path);
    }
  }
}

var handleNotSupportApi = function handleNotSupportApi() {
  var APIName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  errorHandler.warn("".concat(APIName, " is not support,please use Ext.open() or Ext.Router.Bridge.sendScheme() instead"));
};

var Bridge = {
  // 发送广播
  sendBroadcast: function sendBroadcast(opts) {
    // callNativeAPI('QRCTBroadCastManager', 'sendBroadcast', [opts.name, opts.data, opts.hybridId || '']);
    handleNotSupportApi('sendBroadcast');
  },
  // 发送 schema
  sendSchema: function sendSchema(opts) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    console.warn('sendSchema 已纠正为 sendScheme，下个版本将不支持，请升级 QRN');
    callNativeAPI('QRCTJumpHandleManager', 'sendSchema', [opts.url, opts.data, opts.adrToken || '', cb]);
  },
  // 发送 scheme
  sendScheme: function sendScheme(opts) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    callNativeAPI('QRCTJumpHandleManager', 'sendScheme', [opts.url, opts.data, opts.adrToken || '', cb]);
  },
  // 关闭指定 RN VC
  backToReactVC: function backToReactVC(opts) {
    // callNativeAPI('QRCTVCManager', 'backToReactVC', [opts.hybridId || Ext.defaults.hybridId || '', opts.index, opts.adrToken || '', {}]);
    handleNotSupportApi('backToReactVC');
  },
  // 关闭当前 RN VC
  closeCurrentVC: function closeCurrentVC() {
    // callNativeAPI('QRCTVCManager', 'closeCurrentVC', [{}]);
    handleNotSupportApi('closeCurrentVC');
  },
  // 之行 Native 函数
  sendNativeEvents: function sendNativeEvents(opts) {
    // callNativeAPI('QRCTNativeCallbackManager', 'sendNativeEvents', [opts.id, opts.data || {}]);
    handleNotSupportApi('sendNativeEvents');
  },
  // 打开新的 VC
  openNewVC: function openNewVC(opts) {
    // callNativeAPI('QRCTVCManager', 'openNewVC', [opts.hybridId || Ext.defaults.hybridId || '', opts.moduleName || Ext.defaults.appName, opts.data || {}, opts.adrToken || '', {}]);
    handleNotSupportApi('openNewVC');
  },
  // 关闭安卓透明 Activity
  closeActivityAndroid: function closeActivityAndroid(adrToken) {
    // callNativeAPI('QRCTVCManager', 'closeActivity', [adrToken]);
    handleNotSupportApi('closeActivityAndroid');
  },
  // 右滑手势开关
  setSwipeBackEnabled: function setSwipeBackEnabled(isEnabled, vcIndex) {
    var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    // callNativeAPI('QRCTVCManager', 'setSwipeBackEnabled', [isEnabled, vcIndex, cb]);
    handleNotSupportApi('setSwipeBackEnabled');
  }
};
export default Bridge;